module.exports = __webpack_public_path__ + "assets/images/CHF20.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/CHF20.png
// module id = 1339
// module chunks = 1